export default {"src":"/_next/static/media/negative-circle-fill.5d42d974.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};